const _ = require('lodash');
const computed = require('../computed/auth/restore-change');

module.exports = {
    /**
     * Устанавливаем computed поля для страницы восстановления пароля
     * @param {Object} args
     * @param {Object} state
     */
    setComputedFields (args, state) {
        computed.restoreButton(state);
        computed.setRepeatPasswordError(state);
        computed.errorMessage(state);
        computed.errorState(state);
    },

    passwordChange (args, state, output, { locator, context }) {
        let password = state.get(['restoreChange', 'form', 'password']);
        let restoreToken = state.get('restoreToken');

        let API = locator.resolve('api');
        let request = API.passwordChange(context, { password, restoreToken } );

        request.then((data) => {
            let code = _.get(data, 'status.code');

            if (code === 404) {
                output.notFound({ code });
                return;
            }

            if (code === 401) {
                output.invalidToken({ code });
                return;
            }

            if (code !== 200) {
                output.error({ code });
                return;
            }

            output.success({ data });
        })
        .catch((error) => output.error({ error }));
    }
};



// WEBPACK FOOTER //
// ./actions/auth/restore-change.js